module.exports = __webpack_public_path__ + "img/ico_badge04.db0b755e.svg";